import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { useAppContext } from '../Lib/ContextLib';

const CommandPalette = () => {
  const navigate = useNavigate();
  const { accessObject, setShowPage, showCommandPalette, setShowCommandPalette } = useAppContext();
  const [search, setSearch] = useState('');

  const pages = [
    { title: 'Dashboard', description: 'Overview and analytics', path: '/dashboard', category: 'Main', icon: 'fas fa-tachometer-alt', access: accessObject?.dashboardCount },
    { title: 'Admin List', description: 'Manage administrators', path: '/admin-list', category: 'Admin', icon: 'fas fa-user-shield', access: accessObject?.getAdminList },
    { title: 'Total Players', description: 'View all users', path: '/playerlist', category: 'Player', icon: 'fa fa-user-circle', access: accessObject?.getPlayerList },
    { title: 'Live Players', description: 'Current active players', path: '/live-player-app', category: 'Player', icon: 'fa fa-users', access: accessObject?.getLivePlayerAppList },
    { title: 'Banned Players', description: 'Manage restricted users', path: '/playerbanned', category: 'Player', icon: 'fa fa-user-slash', access: accessObject?.getPlayerBannedList },
    { title: 'Ludo Tournament', description: 'Manage ludo games', path: '/ludo-tournament-list', category: 'Games Table', icon: 'fas fa-trophy', access: accessObject?.getEightBallPoolLiteTour },
    { title: 'Chess Tournament', description: 'Manage chess games', path: '/chess-tournament-list', category: 'Games Table', icon: 'fas fa-trophy', access: accessObject?.getEightBallPoolLiteTour },
    { title: 'Block Blast', description: 'Manage block blast games', path: '/block-blast-tournament-list', category: 'Games Table', icon: 'fas fa-trophy', access: accessObject?.getEightBallPoolLiteTour },
    { title: 'Candy Blast', description: 'Manage candy blast games', path: '/candy-blast-tournament-list', category: 'Games Table', icon: 'fas fa-trophy', access: accessObject?.getEightBallPoolLiteTour },
    { title: 'Tickets', description: 'Support and inquiries', path: '/ticket', category: 'Support', icon: 'fas fa-comments', access: accessObject?.contactDetailsList },
    { title: 'Games', description: 'Game configuration', path: '/games', category: 'Controls', icon: 'fas fa-gamepad', access: accessObject?.contactDetailsList },
    { title: 'Tasks', description: 'Reward tasks management', path: '/task', category: 'Controls', icon: 'fas fa-receipt', access: accessObject?.contactDetailsList },
    { title: 'Notification List', description: 'Sent notifications history', path: '/notification', category: 'Notification', icon: 'fas fa-bell', access: accessObject?.getNotificationList },
    { title: 'Banner', description: 'Manage slider banners', path: '/banner', category: 'Controls', icon: 'fas fa-image', access: accessObject?.getBannerList },
    { title: 'Version Control', description: 'App version management', path: '/version', category: 'Controls', icon: 'fas fa-code-branch', access: accessObject?.getVersionListAndroid },
    { title: 'CMS', description: 'Content management system', path: '/cms', category: 'Controls', icon: 'fas fa-file-alt', access: accessObject?.getVersionListAndroid },
    { title: 'Spin Wheel', description: 'Configure lucky spin', path: '/spin-wheel', category: 'Controls', icon: 'fas fa-dharmachakra', access: accessObject?.getRoomTier },
    { title: 'Restricted Area', description: 'Manage blocked regions', path: '/restrictedarea', category: 'Controls', icon: 'fas fa-globe-americas', access: accessObject?.getRestrictedArea },
    { title: 'Polls', description: 'Manage user polls', path: '/poll', category: 'Controls', icon: 'fas fa-poll', access: accessObject?.getRoomTier },
    { title: 'FAQ', description: 'Frequently asked questions', path: '/faq', category: 'Controls', icon: 'fas fa-question-circle', access: accessObject?.getRoomTier },
    { title: 'Payment History', description: 'Transaction logs', path: '/history', category: 'Payment', icon: 'fa fa-history', access: accessObject?.getHistoryList },
    { title: 'Payout Requests', description: 'Manage withdrawal requests', path: '/payout', category: 'Payment', icon: 'fa fa-credit-card', access: accessObject?.getPayoutList },
    { title: 'Bet History', description: 'Player betting logs', path: '/bet', category: 'Payment', icon: 'fa fa-dice', access: accessObject?.getBetList },
    { title: 'Win History', description: 'Player winning logs', path: '/win', category: 'Payment', icon: 'fa fa-trophy', access: accessObject?.getWinList },
    { title: 'Income Details', description: 'Finance and revenue', path: '/income-details', category: 'Finance', icon: 'fas fa-money-bill-wave', access: accessObject?.getAddCashList },
    { title: 'Bonus', description: 'Manage user bonuses', path: '/bonus', category: 'Game Setting', icon: 'fas fa-gift', access: true },
    { title: 'Withdraw', description: 'Manage withdrawals', path: '/withdraw', category: 'Game Setting', icon: 'fas fa-hand-holding-usd', access: true },
    { title: 'Addmoney', description: 'Manage manual deposits', path: '/addmoney', category: 'Game Setting', icon: 'fas fa-plus-circle', access: true },
    { title: 'Setting', description: 'General game settings', path: '/game-setting', category: 'Game Setting', icon: 'fas fa-cog', access: accessObject?.getSetting },
    { title: 'Player Reports', description: 'User analytical reports', path: '/reports-player', category: 'Reports', icon: 'fas fa-chart-line', access: accessObject?.getBotForm },
    { title: 'History Reports', description: 'General history reports', path: '/history-reports', category: 'Reports', icon: 'fas fa-file-invoice', access: accessObject?.getBotForm },
  ];

  const filteredPages = pages.filter(page => 
    page.access === true && 
    (page.title.toLowerCase().includes(search.toLowerCase()) || 
     page.description.toLowerCase().includes(search.toLowerCase()) ||
     page.category.toLowerCase().includes(search.toLowerCase()))
  );

  const handleKeyDown = useCallback((e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
      e.preventDefault();
      setShowCommandPalette(prev => !prev);
    }
  }, [setShowCommandPalette]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  const handleNavigate = (path) => {
    navigate(path);
    setShowCommandPalette(false);
    setSearch('');
    if (setShowPage) setShowPage(false);
  };

  // Group by category
  const categories = [...new Set(filteredPages.map(page => page.category))];

  return (
    <Modal 
      show={showCommandPalette} 
      onHide={() => setShowCommandPalette(false)}
      centered
      className="command-palette-modal"
      size="lg"
    >
      <div className="command-palette-container">
        <div className="command-palette-header">
          <i className="fas fa-search search-icon"></i>
          <input 
            type="text" 
            placeholder="Search pages (Dashboard, Players, Payout...)" 
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
          <div className="command-palette-hint">
            <span className="badge">ESC</span> to close
          </div>
        </div>
        
        <div className="command-palette-body">
          {filteredPages.length === 0 ? (
            <div className="no-results">
              <i className="fas fa-search mb-2"></i>
              <p>No pages found matching "{search}"</p>
            </div>
          ) : (
            categories.map(cat => (
              <div key={cat} className="category-section">
                <div className="category-title">{cat}</div>
                {filteredPages.filter(p => p.category === cat).map(page => (
                  <div 
                    key={page.path} 
                    className="command-item"
                    onClick={() => handleNavigate(page.path)}
                  >
                    <div className="item-details">
                      <div className="item-title">{page.title}</div>
                      <div className="item-description">{page.description}</div>
                    </div>
                    <div className="item-arrow">
                      <i className="fas fa-chevron-right"></i>
                    </div>
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      </div>

      <style>{`
        .command-palette-modal .modal-content {
          background: transparent;
          border: none;
          box-shadow: none;
        }

        .command-palette-container {
          background: #ffffff;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          border: 1px solid #e2e8f0;
          max-height: 80vh;
          display: flex;
          flex-direction: column;
        }

        .command-palette-header {
          display: flex;
          align-items: center;
          padding: 16px 24px;
          border-bottom: 1px solid #f1f5f9;
          position: sticky;
          top: 0;
          background: #fff;
          z-index: 10;
        }

        .command-palette-header .search-icon {
          color: #94a3b8;
          font-size: 1.2rem;
          margin-right: 16px;
        }

        .command-palette-header input {
          flex: 1;
          border: none;
          outline: none;
          font-size: 1.1rem;
          color: #1e293b;
          background: transparent;
        }

        .command-palette-header .command-palette-hint {
          margin-left: 16px;
        }

        .command-palette-header .badge {
          background: #f1f5f9;
          color: #64748b;
          font-weight: 600;
          padding: 4px 8px;
          border-radius: 6px;
          font-size: 0.75rem;
          border: 1px solid #e2e8f0;
        }

        .command-palette-body {
          padding: 12px;
          overflow-y: auto;
        }

        .category-section {
          margin-bottom: 16px;
        }

        .category-title {
          font-size: 0.75rem;
          font-weight: 700;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          padding: 8px 12px;
        }

        .command-item {
          display: flex;
          align-items: center;
          padding: 10px 12px;
          border-radius: 12px;
          cursor: pointer;
          transition: none;
          margin-bottom: 2px;
        }

        .command-item .item-details {
          flex: 1;
        }

        .command-item .item-title {
          font-size: 0.95rem;
          font-weight: 600;
          color: #1e293b;
        }

        .command-item .item-description {
          font-size: 0.8rem;
          color: #64748b;
        }

        .command-item .item-arrow {
          color: #cbd5e1;
          font-size: 0.8rem;
          opacity: 1;
        }

        .no-results {
          padding: 48px;
          text-align: center;
          color: #94a3b8;
        }

        .no-results i {
          font-size: 2rem;
          display: block;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .command-palette-container {
            width: 95%;
            margin: 0 auto;
          }
        }
      `}</style>
    </Modal>
  );
};

export default CommandPalette;
